import { API_BASE_PATH } from '../App/constants'

export function getBaseRUIANURL(): string {
  return `${API_BASE_PATH}/cs/ruian/search`
}
